import { render, staticRenderFns } from "./PlanSelectForFreePane.vue?vue&type=template&id=2d380713&scoped=true"
import script from "./PlanSelectForFreePane.vue?vue&type=script&lang=ts"
export * from "./PlanSelectForFreePane.vue?vue&type=script&lang=ts"
import style0 from "./PlanSelectForFreePane.vue?vue&type=style&index=0&id=2d380713&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d380713",
  null
  
)

export default component.exports